module.exports = __webpack_public_path__ + "img/keenguin.904fcf3b.jpg";